import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Option = ({ children, isSelected, data, selectOption, isDisabled, isFocused }) => (
  <button
    type="button"
    className={
      classnames(
        'c-language-multi-select__option',
        {
          'c-language-multi-select__option_focused': isFocused && !isDisabled,
        }
      )
    }
    onClick={() => selectOption(data)}
    disabled={isDisabled}
  >
    {children}
    <div className="c-checkbox c-checkbox_small c-language-multi-select__option__checkbox">
      <label className="c-checkbox__label">
        <input
          className="c-checkbox__input"
          type="checkbox"
          checked={isSelected}
          disabled={isDisabled}
        />
        <span className="c-checkbox__trigger" />
      </label>
    </div>
  </button>
);

Option.propTypes = {
  children: PropTypes.node.isRequired,
  isSelected: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  selectOption: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool.isRequired,
};

export default Option;
